import React from 'react';
import { App, View } from '@gin-betting/core';
import cn from 'classnames';

import SmartLink from '../SmartLink';
import MatchDateTime from '../MatchDateTime';
import PromoMatchDynamicScoreList from '../PromoMatchDynamicScoreList';
import { ParentPath } from 'types';
import './topBannerMatchInfo.scss';

const tournamentPropsToPick = ['id' as const, 'name' as const, 'slug' as const];

interface Props {
    tournament: Pick<
        View.Tournament,
        typeof tournamentPropsToPick[number]
    > | null;
    startTime: string | undefined;
    isLive: boolean;
    route: ParentPath;
    marketName: string;
    score?: string;
    matchId: string | null;
    sportId: string | undefined;
    dateFormat: string;
}

const TopBannerMatchInfo: React.FC<Props> = ({
    tournament,
    startTime,
    route,
    isLive,
    marketName,
    score,
    matchId,
    sportId,
    dateFormat,
}) => {
    return (
        <div
            styleName="container"
            className="__app-TopBannerMatchInfo-container"
        >
            {tournament && (
                <div
                    styleName="tournament"
                    className="__app-TopBannerMatchInfo-tournament"
                >
                    <SmartLink
                        to={`${route}${App.Routes.TOURNAMENT}${tournament.slug}`}
                    >
                        {tournament.name}
                    </SmartLink>
                </div>
            )}

            {sportId && startTime && matchId && (
                <MatchDateTime
                    sportId={sportId}
                    startTime={startTime}
                    isLive={isLive}
                    isSmall={true}
                    liveCoverage={false}
                    matchId={matchId}
                    dateFormat={dateFormat}
                />
            )}

            {sportId && matchId && isLive && (
                <div styleName="score">
                    <PromoMatchDynamicScoreList
                        sportId={sportId}
                        matchId={matchId}
                        showDynamicScores={false}
                    />
                </div>
            )}

            <div
                styleName={cn('market-name', { 'is-score': isLive && score })}
                className="__app-TopBannerMatchInfo-market-name"
            >
                {marketName || <span>-</span>}
            </div>
        </div>
    );
};

export default React.memo(TopBannerMatchInfo);
